import { useState } from 'react';
import CONFIG from '../../constanta/config';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useQuery } from '../../hook/useQuery';
import { useForm } from 'react-hook-form';

const FormAdminResult = (props) => {
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const query = useQuery();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm();

  const onSubmit = (data) => {
    if (loading) return;

    setLoading(true);
    const payload = {
      fullname: props?.user?.fullname,
      qr_code: data.attendee_code
     };

    try {
      axios
        .post(CONFIG.URL + "/user/bypass", payload, {
          headers: {
            token: props?.user?.token,
          },
        })
        .then(function (response) {
          setLoading(false);
          if (response.status === 200 && response.data?.status !== "error") {
            props.onSuccess(data);
          } else {
            setMsg("Error: " + response.data?.message);
          }
        })
        .catch(function (error) {
          setMsg("Error: Something went wrong please try again");
          setLoading(false);
        });
    } catch (error) {
      setMsg("Error: Something went wrong please try again");
      setLoading(false);
    }
  };

  const handleCheckin = async (data) => {
    const payload = {
      admin_code: props?.user?.qr_code,
      id_gate: query.get('id_gate'),
      attendee_code: data.attendee_code,
      gate_name: query.get('gate')
    };

    const form_data = new FormData();
    Object.keys(payload).forEach((key) => form_data.append(key, payload[key]));

    try {
      const response = await axios.post(
        CONFIG.URL + '/event/adminCode',
        form_data,
        {
          headers: {
            token: Cookies.get('token')
          }
        }
      );

      if (response?.data?.status === 'SUCCESS') {
        props.onSuccess();
        resetForm();
      } else {
        setMsg(response?.data?.message || 'Invalid attendee code');
      }
    } catch (error) {
      setMsg('An error occurred during check-in');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setValue('attendee_code', '');
    setMsg('');
    reset();
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="space-y-5 px-5 py-3 bg-white rounded-md flex flex-col w-full md:w-1/2">
      <div className="text-center font-bold text-xl uppercase">
        {query.get('gate')} Gate
      </div>

      <div className="bg-blue-500 w-full text-center py-2 text-white font-bold rounded">
        ADMIN PASS
      </div>

      <div className="w-full">
        <div className="flex justify-between mb-1">
          <label className="font-bold">SCAN ATTENDEE QR / RFID</label>
          <button
            type="button"
            onClick={resetForm}
            className="bg-red-500 px-2 py-1 text-white text-xs rounded font-bold">
            Clear
          </button>
        </div>

        <input
          autoFocus
          autoComplete="off"
          className={`border-2 px-2 h-[38px] rounded w-full ${
            errors.attendee_code ? 'border-red-500' : ''
          }`}
          {...register('attendee_code', {
            required: 'Attendee code is required'
          })}
        />

        {errors.attendee_code && (
          <span className="text-red-500 text-sm font-bold">
            {errors.attendee_code.message}
          </span>
        )}
      </div>

      {msg && <span className="text-red-500 text-sm font-bold">{msg}</span>}

      <div className="flex space-x-4">
        <button
          type="button"
          onClick={props.ok}
          className="px-10 py-2 rounded-lg text-white font-bold bg-red-500 w-full">
          CANCEL
        </button>

        <button
          type="submit"
          disabled={loading}
          className="px-10 py-2 rounded-lg text-white font-bold bg-green-500 w-full">
          {loading ? 'Loading...' : 'CONFIRM'}
        </button>
      </div>
    </form>
  );
};

export default FormAdminResult;
